// WARNING, do not change the value of these keys because then
// they will not be found on future retrieval

export enum StorageKeys {
  AdviceEncounterType = "Advice-EncounterType",
  AdviceFacilityId = "Advice-FacilityId",
  AdviceCodeType = "Advice-CodeType",
}
